<template>
  <div
    :class="{
      'inline-editable-text': true,
      'is-inline': inline
    }"
    v-tooltip="( tooltip === null || !isEditable )
      ? {}
      : { content: tooltip ? tooltip : 'Click to edit' }">
    <div
      :contenteditable="isEditable && active"
      :class="{
        'inline-editable-text__text': true,
        'has-no-buttons': hideButtons
      }"
      :style="lineThroughStyle"
      @keydown.enter.prevent="updateText"
      @keydown.escape.prevent="cancelUpdate"
      @keydown.38="onKeyDown"
      @keydown.39="onKeyDown"
      @keydown.40="onKeyDown"
      @keyup="onKeyUp"
      @focus="onFocus"
      @click.prevent="onClickText"
      @blur.native="lostFocus"
      @blur="lostFocus"
      @drag.prevent=""
      ref="text_input"
      v-html="content">
    </div>
    <!--<div v-else
      :contenteditable="isEditable && active"
      :class="{
        'inline-editable-text__text': true,
        'has-no-buttons': hideButtons
      }"
      :style="lineThroughStyle"
      @keydown.enter.prevent="updateText"
      @keydown.escape.prevent="cancelUpdate"
      @keydown.38="onKeyDown"
      @keydown.39="onKeyDown"
      @keydown.40="onKeyDown"
      @keyup="onKeyUp"
      @focus="onFocus"
      @click.prevent="onClickText"
      @blur.native="lostFocus"
      ref="text_input"
      v-html="content"
      v-on-clickaway="onClickAway">
    </div>-->
    <div
      v-if="!hideButtons"
      :class="{
        'inline-editable-text__buttons' : true,
        'buttons-below'                 : true,
        'buttons-non-floating'          : !floatingButtons
      }">
      <!-- INFO: We have to use mousedown.native here otherwise lost focus will fire before the click event -->
      <el-button size="mini" type="success" @mousedown.native="updateText()">Save</el-button>
      <el-button size="mini" type="button" @mousedown.native="cancelUpdate(true)">Cancel</el-button>
    </div>
  </div>
</template>

<script>
import clonedeep from 'lodash.clonedeep';
//import { mixin as clickaway } from 'vue-clickaway';

export default {
  //mixins: [ clickaway ],
  props: {
    inline: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "add title here"
    },
    id: {
      type: String
    },
    tooltip: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: ""
    },
    lineThrough: {
      type: Boolean,
      default: false
    },
    hideButtons: {
      type: Boolean,
      default: false
    },
    floatingButtons: {
      type: Boolean,
      default: true
    },
    resetOnUpdate: {
      /* Should the text be set to '' when @change is send? */
      type: Boolean,
      default: false
    },
    resetOnCancel: {
      /* Reset when user clicks 'cancel'. Useful when used as list input */
      type: Boolean,
      default: false
    },
    lostFocusIsUpdate: {
      /* Should an @change event be send when focus is lost? (like Trello) */
      type: Boolean,
      default: false
    },
    isEditable: {
      /* Whether the text is editable. Used to disable user input, when not allowed */
      type: Boolean,
      default: true
    },
    isDraggable: {
      type: Boolean,
      default: false
    },
    forceBlur: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: false,
      text: '',
      hasUnsavedChanges: false,
      editModeActive: false,
      textBefore: ''
    };
  },
  created() {
    this.active = !this.isDraggable
    this.text = this.value
  },
  watch: {
    value( new_value ) {
      this.text = new_value
    },
    id() {
      /* Set edit mode to false when id is changed */
      this.blur()
    }
  },
  computed: {
    content () {
      return this.text === '' ? this.placeholder : this.text;
    },
    lineThroughStyle() {
      return {
        'text-decoration': this.lineThrough ? 'line-through' : ''
      }
    }
  },
  methods: {
    onClickText(e) {
      this.active = true;
      this.$nextTick(() => {
        this.focus();
      })
    },

    select() {
      let element = this.$refs.text_input;
      if ( document.body.createTextRange ) {
        let range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if ( window.getSelection ) {
        let selection = window.getSelection();
        let range = document.createRange();
        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    },

    focus() {
      this.$emit("focus");
      this.onFocus()
      this.$refs.text_input.focus()
      this.hasUnsavedChanges = true;

      // HACK!
      if ( this.text === 'Untitled' ) {
        this.select()
      }
    },

    blur() {
      this.lostFocus();
      this.$refs.text_input.blur()
    },

    onClickAway() {
      if (this.forceBlur) {
        this.blur()
      }
    },

    reset() {
      this.text = ''
      this.textBefore = ''
      this.$refs.text_input.innerText = ''
    },

    updateText() {
      if (this.$refs.text_input.innerText === '') {
        this.$refs.text_input.innerText = this.placeholder
      }
      if ( this.$refs.text_input.innerText !== '') {
        if (this.hasUnsavedChanges) {
          let text = clonedeep(this.$refs.text_input.innerText)
          this.hasUnsavedChanges = false;
          this.$emit("change", text);
          if (this.resetOnUpdate) {
            this.reset()
          }
        }
      }
      if (!this.resetOnUpdate) {
        this.$refs.text_input.blur()
        this.editModeActive = false;
      }
      this.textBefore = this.text
    },

    cancelUpdate(reset = false) {
      this.editModeActive = false;
      if ( reset ) {
        if ( this.resetOnCancel ) {
          this.reset()
        }
      } else {
        this.text = this.textBefore
      }
      if (this.text === '') {
        this.$refs.text_input.innerText = this.placeholder
      } else {
        this.$refs.text_input.innerText = this.text
      }
      this.$emit("cancel");

      this.$refs.text_input.blur()
    },

    onFocus() {
      if ( !this.isEditable ) {
        return false
      }
      if (this.$refs.text_input.innerText === this.placeholder) {
        this.$refs.text_input.innerText = ''
      }
      this.editModeActive = true;
      this.textBefore = this.text
      this.$emit('enter-edit-mode')
    },

    lostFocus() {
      if ( this.isDraggable ) {
        this.active = false;
      }
      if (this.text === this.textBefore && this.$refs.text_input.innerText === this.textBefore) {
        this.editModeActive = false;
        if (this.text === '' && this.$refs.text_input.innerText === '') {
          this.$refs.text_input.innerText = this.placeholder
        }
      } else {
        if ( this.lostFocusIsUpdate ) {
          this.updateText()
        }
      }
      this.$emit("lost-focus", this.$refs.text_input.innerText);
    },

    onKeyUp($event) {
      this.$emit("keyupevent", $event);
      this.hasUnsavedChanges = true
      let text = clonedeep(this.$refs.text_input.innerText)
      this.$emit("update", text);
    },

    onKeyDown($event) {
      if ($event.key === 'Escape') {
        this.cancelUpdate()
      } else if ($event.key === 'Enter') {
        this.updateText()
      } else {
        this.$emit("keydownevent", $event);
        this.hasUnsavedChanges = true
        let text = clonedeep(this.$refs.text_input.innerText)
        this.$emit("update", text);
      }
    }
  }
};
</script>

<style>
.inline-editable-text {
  /* display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center; */
  position: relative;
  min-width: 150px;
  min-height: 1.5em;
}
.inline-editable-text.is-inline,
.inline-editable-text.is-inline .inline-editable-text__text {
  display: inline-block;
  /*user-select: none;*/
}
.inline-editable-text__text.has-no-buttons:focus {
  border-radius: 6px;
}
.inline-editable-text__text {
  white-space: normal;
  text-overflow: ellipsis;
  min-width: 150px;
  min-height: 1.5em;
}
.inline-editable-text__text:hover {
  border: none;

  /* fix bug in Firefox, where element has heigh 0 when empty */
  min-height: 1.5em;
}
.inline-editable-text__text:focus {
  padding: 2px;

  /* Pulsing border */
  border: 2px solid #454545;
  animation: PulseAttention 1.5s cubic-bezier(0.215, 0.61, 0.355, 1) forwards infinite;

  /* Inner shadow and background */
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: inset 2px 2px 3px rgba(0, 0, 0, 0.4);

  /* remove browser box */
  outline: none;

  /* radius top */
  border-radius: 6px 6px 0 0;

  /* Always move to front */
  z-index: 9999;
}
@keyframes PulseAttention {
  50% {
    border-color: rgb(64, 158, 255);
  }
}
.inline-editable-text__text:focus + .inline-editable-text__buttons.buttons-below {
  display: block;
}
.inline-editable-text__buttons {
  margin-left: 0;
  display: flex;
  flex-wrap: nowrap;
  font-size: 10pt;
}
.inline-editable-text__buttons.buttons-below {
  display: none;
  position: absolute;
  padding: 5px;
  right: 0;
  bottom: -38px;
  width: 100%;
  /* background-color: white; */
  border-radius: 0 0 6px 6px;
  /* border: 1px solid #efefef; */
  z-index: 10;
  background-color: #454545;
  border: none;
}
.inline-editable-text__buttons.buttons-below.buttons-non-floating {
  position: relative;
  margin-top: 0;
  bottom: 0;
  z-index: 10;
}
</style>
